<ng-container *transloco="let t; read: 'layout.navigation'">
  <a mat-list-item
    [routerLink]="item.route"
    [routerLinkActive]="'active'"
    class="nav-item"
    [ngClass]="{'child': isChild}"
  >
    <mat-icon [ngClass]="{'hide': !item.icon }" matListIcon>{{item.icon}}</mat-icon>
    <span>{{ t(item.label) }}</span>
  </a>
</ng-container>
